function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: rgba(0,0,0,.5);\n  color: #fff;\n  padding: 2px 5px;\n  font-size: 9px;\n  line-height: 12px;\n  text-align: right;\n  display: block;\n  bottom: 0;\n  right: 0;\n  pointer-events: none;\n  transition: opacity .2s;\n  &:hover { opacity: 0; }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n  font-size: 0;\n  color: transparent;\n  border: 0;\n  background: transparent;\n  button {\n    position: absolute;\n    cursor: pointer;\n    display: block;\n    width: 100%;\n    height: 100%;\n    font-size: 0;\n    color: transparent;\n    border: 0;\n    background: transparent;\n    &, &:focus, &:active, &:hover { outline: none; }\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  transform: translate(0,-50%);\n  top: 50%;\n  right: 0;\n  background: transparent;\n  ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  transform: translate(0,-50%);\n  top: 50%;\n  left: 0;\n  background: transparent;\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  top: 0;\n  right: 0;\n  background: rgba(0,0,0,.5);\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  img {\n    transition: opacity .3s ease;\n    &.hidden {\n      opacity: 0;\n    }\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  position: relative;\n  background-color: #000;\n  overflow: auto;\n  -webkit-overflow-scrolling: auto;\n  -webkit-overflow-scrolling: touch;\n  overflow-y: scroll;\n  &::before {\n    content: '';\n    padding-top: ", "%;\n    display: block;\n  }\n  > iframe {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    border: 0;\n    @supports (-webkit-overflow-scrolling: touch) {\n      height: 0;\n      max-height: 100%;\n      max-width: 100%;\n      min-height: 100%;\n      min-width: 100%;\n      width: 0;\n    }\n    @media only screen and (max-width : 1366px) and (orientation : landscape) {\n      transform: scale(.85);\n      transform-origin: 50% 0;\n    }\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  display: flex;\n  height: 100%;\n  height: calc(100% + 4px);\n  width: 100%;\n  width: calc(100% + 4px);\n  justify-content: center;\n  align-items: center;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  background: rgba(0,0,0,.75);\n  color: #fff;\n  padding: 15px;\n  font-size: 14px;\n  display: block;\n  bottom: 0;\n  left: 50%;\n  transform: translate(-50%,0);\n  pointer-events: none;\n  transition: opacity .2s;\n  &:hover { opacity: 0; }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  height: 100%;\n  width: 100%;\n  max-height: 100%;\n  max-width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: transparent;\n  color: red;\n  border: 0;\n  text-transform: uppercase;\n  transition: all .3s;\n  z-index: 1000;\n  height: 20px;\n  font-size: 16px;\n\n  @media (min-width: 800px) {\n    height: 50px;\n    font-size: 20px;\n  }\n  &.active {\n    color: green;\n  }\n  svg { margin-left: 10px; }\n  &:hover {\n    box-shadow: 0 5px 8px 0 rgba(0,0,0,0.2);\n    background: #fff;\n    color: #000;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n  position: fixed;\n  top: 0px;\n  right: 0px;\n  background: transparent;\n  color: #fff;\n  border: 0;\n  transition: all .3s;\n  z-index: 1000;\n  height: 30px;\n  font-size: 20px;\n  .title {\n    font-size: .55em;\n    font-weight: 400;\n    margin-right: 10px;\n  }\n\n  @media (min-width: 800px) {\n    height: 50px;\n    font-size: 30px;\n  }\n  &:hover {\n    box-shadow: 0 5px 8px 0 rgba(0,0,0,0.2);\n    background: #fff;\n    color: #000;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  padding: 0;\n  background: #000;\n  pre {\n    margin-bottom: 1.5em;\n    border: 1px solid #393937;\n    overflow: hidden;\n    background-color: #191917;\n    color: #fff;\n    white-space: normal;\n    font: inherit;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: all .3s ease-in-out;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgba(48, 49, 48, 0.42);\n  height: 100%;\n  position: fixed;\n  transition: all .3s ease-in-out;\n  width: 100%;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%,-50%);\n  background-color: #000;\n  box-shadow: 0 5px 8px 0 rgba(0,0,0,0.2), 0 7px 20px 0 rgba(0,0,0,0.17);\n  height: 100%;\n  width: 100%;\n  min-width: 340px;\n  min-height: 500px;\n  transition: all .3s ease-in-out;\n  z-index: 10010;\n  opacity: 0;\n  padding: 30px 20px;\n  &, * { box-sizing: border-box; }\n\n  @media (min-width: 800px) {\n    padding: 50px;\n  }\n\n  .emag-viewer-modal {\n    padding: 35px;\n    .emag-viewer-modal-close {\n      top: 0;\n      right: 0;\n      cursor: pointer;\n      svg {\n        width: 35px;\n        height: 35px;\n        mix-blend-mode: difference;\n        transition: transform .3s ease;\n        path {\n          fill: #fff;\n          transition: all .3s ease;\n        }\n      }\n      &:hover {\n        svg {\n          transform: scale(1.1);\n        }\n      }\n      @media (max-width: 1280px) {\n        top: 0;\n        right: 0;\n      }\n    }\n    &.emag-viewer-modal-iframe {\n      width: 1200px;\n      max-width: 100%;\n      box-shadow: none;\n      .emag-viewer-modal-close {\n        top: 30px;\n        right: 30px;\n        background: #fff;\n      }\n    }\n    &.emag-viewer-modal-slideshow {\n      padding: 40px 0 0;\n      background: transparent;\n      max-width: 100%;\n      .swiper-slide {\n        padding: 0;\n        text-align: center;\n        background: #fff;\n        img {\n          display: inline-block;\n          max-width: 100%;\n          height: auto;\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FiX, FiCheck, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Loader from 'react-loader-spinner';
var rotate = keyframes(_templateObject());
export var classes = {
  iframe: {
    modal: 'emag-viewer-modal emag-viewer-modal-iframe',
    overlay: 'emag-viewer-modal-overlay',
    closeButton: 'emag-viewer-modal-close'
  },
  slideshow: {
    modal: 'emag-viewer-modal emag-viewer-modal-slideshow',
    overlay: 'emag-viewer-modal-overlay',
    closeButton: 'emag-viewer-modal-close'
  }
};
export var Modal = styled.div(_templateObject2());
export var ModalBackDrop = styled.div(_templateObject3());
export var ModalLoadingWithoutLoader = styled.div(_templateObject4(), function (props) {
  return props.background ? props.background : 'rgba(0, 0, 0, 0.3)';
});
export var ModalLoading = function ModalLoading(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return /*#__PURE__*/React.createElement(ModalLoadingWithoutLoader, props, /*#__PURE__*/React.createElement(Loader, {
    type: "Oval",
    color: color ? color : "#fff",
    height: 100,
    width: 100
  }));
};
export var ModalWrapper = styled.div(_templateObject5());
export var ModalBody = styled.div(_templateObject6());
export var ModalCloseBtnWithoutIcon = styled.button(_templateObject7());
export var ModalCloseBtn = function ModalCloseBtn(props) {
  return /*#__PURE__*/React.createElement(ModalCloseBtnWithoutIcon, props, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, props.title), /*#__PURE__*/React.createElement(FiX, null));
};
export var ModalToggleDebugBtnWithoutIcon = styled.button(_templateObject8());
export var ModalToggleDebugBtn = function ModalToggleDebugBtn(_ref2) {
  var active = _ref2.active,
      props = _objectWithoutProperties(_ref2, ["active"]);

  return /*#__PURE__*/React.createElement(ModalToggleDebugBtnWithoutIcon, _extends({
    className: active ? 'active' : ''
  }, props), "Debug", active ? /*#__PURE__*/React.createElement(FiCheck, null) : /*#__PURE__*/React.createElement(FiX, null));
};
export var Page = styled.div(_templateObject9());
export var DebugPage = styled.div(_templateObject10());
export var PageLightbox = styled.div(_templateObject11());
export var PageLightboxIframeWrapper = styled.div(_templateObject12(), function (props) {
  return (props.size && props.size.height && props.size.width ? props.size.height / props.size.width : 9 / 16) * 100;
});
export var PageLightboxSlideshowWrapper = styled.div(_templateObject13());
var pageLightboxControls = "\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 50px;\n  height: 50px;\n  color: #fff;\n  font-size: 30px;\n  border: 0;\n  transition: all .3s;\n  z-index: 10;\n  &:hover {\n    box-shadow: 0 5px 8px 0 rgba(0,0,0,0.2);\n    background: #fff;\n    color: #000;\n  }\n";
export var PageLightboxCloseWithoutIcon = styled.button(_templateObject14(), pageLightboxControls);
export var PageLightboxClose = function PageLightboxClose(props) {
  return /*#__PURE__*/React.createElement(PageLightboxCloseWithoutIcon, props, /*#__PURE__*/React.createElement(FiX, null));
};
export var PageLightboxPreviousWithoutIcon = styled.button(_templateObject15(), pageLightboxControls);
export var PageLightboxPrevious = function PageLightboxPrevious(props) {
  return /*#__PURE__*/React.createElement(PageLightboxPreviousWithoutIcon, props, /*#__PURE__*/React.createElement(FiChevronLeft, null));
};
export var PageLightboxNextWithoutIcon = styled.button(_templateObject16(), pageLightboxControls);
export var PageLightboxNext = function PageLightboxNext(props) {
  return /*#__PURE__*/React.createElement(PageLightboxNextWithoutIcon, props, /*#__PURE__*/React.createElement(FiChevronRight, null));
};
export var Region = styled.div(_templateObject17());
export var DebugRegion = styled.div(_templateObject18());
export default {
  Modal: Modal,
  ModalBackDrop: ModalBackDrop,
  ModalLoading: ModalLoading,
  ModalWrapper: ModalWrapper,
  ModalBody: ModalBody,
  ModalCloseBtn: ModalCloseBtn,
  ModalToggleDebugBtn: ModalToggleDebugBtn,
  Page: Page,
  DebugPage: DebugPage,
  PageLightbox: PageLightbox,
  PageLightboxClose: PageLightboxClose,
  Region: Region,
  DebugRegion: DebugRegion
};